// language=GraphQL
export const ALL_COLLECTIVE_ADDONS_QUERY = `query Query($withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
  collectiveAddons: ratioCollectiveAddons {
    id
    label
    info
    ageGroupServices @include(if: $withAgeGroupServices) {
      id
      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_COLLECTIVE_ADDON_QUERY = `query Query($id: ID!, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
  collectiveAddon: ratioCollectiveAddon(id: $id) {
    id
    label
    info
    ageGroupServices @include(if: $withAgeGroupServices) {
      id
      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      ratioServiceNo
    }
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_COLLECTIVE_ADDON_MUTATION = `
  mutation Mutation($input: CreateRatioCollectiveAddonInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
    collectiveAddon: createRatioCollectiveAddon(input: $input) {
      id
      label
      info
      ageGroupServices @include(if: $withAgeGroupServices) {
        id
        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_COLLECTIVE_ADDON_MUTATION = `
  mutation Mutation($input: UpdateRatioCollectiveAddonInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {
    collectiveAddon: updateRatioCollectiveAddon(input: $input) {
      id
      label
      info
      ageGroupServices @include(if: $withAgeGroupServices) {
        id
        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_COLLECTIVE_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioCollectiveAddonInput) {
    deleteRatioCollectiveAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_COLLECTIVE_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioCollectiveAddonInput) {
    forceDeleteRatioCollectiveAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: addRatioCollectiveAddonAgeGroupServicesInput) {
    addRatioCollectiveAddonAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const REMOVE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: removeRatioCollectiveAddonAgeGroupServicesInput) {
    removeRatioCollectiveAddonAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const CREATE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: createRatioCollectiveAddonAgeGroupServicesInput) {
    createRatioCollectiveAddonAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const DELETE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = `
  mutation Mutation($input: deleteRatioCollectiveAddonAgeGroupServicesInput) {
    deleteRatioCollectiveAddonAgeGroupServices(input: $input) {
      id
      ageGroupServiceIds
    }
  }`

// language=GraphQL
export const COLLECTIVE_ADDONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false) {
  groupedDependents: ratioCollectiveAddonDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus    }
  }
}`
